<template>
  <div>
  <text-box-title class="mt-3" title="Board of Revision Cases">
      <note-documents note-id="44" class="ml-3 mr-3 mt-3"></note-documents>
  </text-box-title>
  <text-box-title class="mt-3" title="Board of Revision Counter-complaints">
      <note-documents note-id="47" class="ml-3 mr-3 mt-3"></note-documents>
  </text-box-title>
  </div>
</template>

<script>
import PageHeadingInfo from '@/components/layout/PageHeadingInfo.vue'
import TextBoxTitle from '@/components/layout/TextBoxTitle.vue'
import LinkBox from '@/components/layout/LinkBox.vue'
import NoteDocuments from '@/components/display-utils/NoteDocuments.vue'

export default {
  components: {
    PageHeadingInfo,
    TextBoxTitle,
    LinkBox,
    NoteDocuments
  },
  data () {
    return {}
  }
}
</script>
